import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput } from 'elements'
import { clientsSelector, currentClientStatusSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listClients } from 'redux/modules/model/client'
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'

const predicate = (criteria) => (item) => {
    if (criteria.search) {
        const ucSearch = criteria.search.toUpperCase()
        return item.clientId.toUpperCase().includes(ucSearch) ||
            item.displayName.toUpperCase().includes(ucSearch)
    }
    return true
}

class ClientList extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        listClients: PropTypes.func.isRequired,
        logUserTab: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        clientList: PropTypes.array.isRequired,
        operatorListStatus: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props)
        this.state = {
            search: null
        }
    }

    componentDidMount() {
        const { clientId, listClients, logUserTab } = this.props
        listClients({ clientId })
        const tab = "Client"
        logUserTab({ clientId, tab })
    }

    setURLHref = (params) => {
        const { history } = this.props
        history.push({
            location: ROUTES.DIRECTORY,
            search: jsonToQueryString(params)
        })
    };

    handleViewModeChange = (view) => {
        const { location } = this.props
        const params = {
            ...parseQueryString(location.search),
            view
        }
        this.setURLHref(params)
    };

    handleSearchChange = (e) => {
        this.setState({
            search: e.target.value
        })
    }

    render() {
        const { clientList, operatorListStatus, location } = this.props
        const params = parseQueryString(location.search)
        const { view = 'list' } = params
        const criteria = {
            ...params,
            search: this.state.search || params.search
        }
        const filteredClients = fp.filter(predicate(criteria))(clientList)

        return (
            <div>
                <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
                {API_PENDING === operatorListStatus && <Spinner />}
                {API_SUCCESS === operatorListStatus && <ListView clients={filteredClients} />}
                {API_FAIL === operatorListStatus && <h2>Failed to load clients</h2>}
            </div>
        )
    }
}

export const selector = createStructuredSelector({
    clientList: clientsSelector,
    operatorListStatus: currentClientStatusSelector
})

export const actions = {
    listClients,
    logUserTab
}

export default compose(
    withRouter,
    withClientId,
    connect(selector, actions),
)(ClientList)



// WEBPACK FOOTER //
// ./src/pages/client/client-list/index.js